// extracted by mini-css-extract-plugin
export default {"FacebookButton":"FacebookLoginButton_FacebookButton__OH9eU"};